import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/refer")({
  beforeLoad: () => {
    throw redirect({ to: "/learning-journeys", replace: true, statusCode: 301 });
  },
});
